import { render, staticRenderFns } from "./PeriodBtn.vue?vue&type=template&id=7da72dea&"
import script from "./PeriodBtn.vue?vue&type=script&lang=ts&"
export * from "./PeriodBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports